import "./IvError.css";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Table, Modal } from 'react-bootstrap';
import { getIvFieldValue } from "../../utils/ivErrorDataUtils";

// 비트맵 정의
const AlarmModalData = {
  1: {
    title: "0x002F Mode 상태 정보",
    rows: [
      { bit: "Bit15", desc: "고장 상태", code: "0x8000" },
      { bit: "Bit14", desc: "전원 인가 직후 내부 회로, 센서, 통신 체크 중", code: "0x4000" },
      { bit: "Bit13", desc: "대기 상태", code: "0x2000" },
      { bit: "Bit12", desc: "정상 운전 중", code: "0x1000" },
      { bit: "Bit11", desc: "출력 제한 운전", code: "0x0800" },
      { bit: "Bit10", desc: "", code: "" },
      { bit: "Bit9", desc: "", code: "" },
      { bit: "Bit8", desc: "", code: "" },
      { bit: "Bit7", desc: "", code: "" },
      { bit: "Bit6", desc: "", code: "" },
      { bit: "Bit5", desc: "", code: "" },
      { bit: "Bit4", desc: "", code: "" },
      { bit: "Bit3", desc: "", code: "" },
      { bit: "Bit2", desc: "", code: "" },
      { bit: "Bit1", desc: "", code: "" },
      { bit: "Bit0", desc: "", code: "" }
    ]
  },

  2: {
    title: "0x0036 Fault0 상태 정보",
    rows: [
      { bit: "Bit15", desc: "인버터 전류 오프셋 이상", code: "IntFanErr" },
      { bit: "Bit14", desc: "과온 보호", code: "TempOver" },
      { bit: "Bit13", desc: "계통 연결 릴레이 이상", code: "Protect0020" },
      { bit: "Bit12", desc: "상 불일치", code: "GridV.OutLim" },
      { bit: "Bit11", desc: "계통 저주파", code: "GridF.OutLim" },
      { bit: "Bit10", desc: "계통 과주파", code: "GridF.OutLim" },
      { bit: "Bit9",  desc: "인버터 출력 과전류", code: "Protect0030" },
      { bit: "Bit8",  desc: "계통 상전압 과전압", code: "GridV.OutLim" },
      { bit: "Bit7",  desc: "계통 선간전압 과전압", code: "GridV.OutLim" },
      { bit: "Bit6",  desc: "MPPT1 입력 전류 과다", code: "Protect0040" },
      { bit: "Bit5",  desc: "Reserved", code: "" },
      { bit: "Bit4",  desc: "인버터 소프트스타트 시간 초과", code: "Protect0050" },
      { bit: "Bit3",  desc: "DC BUS 기동 실패", code: "Protect0060" },
      { bit: "Bit2",  desc: "DC BUS 전압 불균형", code: "Protect0070" },
      { bit: "Bit1",  desc: "Reserved", code: "" },
      { bit: "Bit0",  desc: "DC BUS 합전압 과다", code: "Protect0090" }
    ]
  },
  3: {
    title: "0x0037 Fault1 상태 정보",
    rows: [
      { bit: "Bit15", desc: "누설전류 센서 이상", code: "Protect0100" },
      { bit: "Bit14", desc: "DC BUS 하드웨어 과전압", code: "Protect0110" },
      { bit: "Bit13", desc: "Reserved", code: "" },
      { bit: "Bit12", desc: "전력 모듈 보호", code: "Protect0120" },
      { bit: "Bit11", desc: "상전류 불균형", code: "Protect0130" },
      { bit: "Bit10", desc: "Reserved", code: "" },
      { bit: "Bit9", desc: "계통 전압 불균형", code: "GridV.OutLim" },
      { bit: "Bit8", desc: "하드웨어 과전류 보호", code: "Protect0140" },
      { bit: "Bit7", desc: "MCU 내부 보호", code: "Protect0150" },
      { bit: "Bit6", desc: "Reserved", code: "" },
      { bit: "Bit5", desc: "주파수 설정 이상", code: "Protect0160" },
      { bit: "Bit4", desc: "누설전류 과다", code: "GFCIErr" },
      { bit: "Bit3", desc: "절연 저항 저하", code: "IsolationErr" },
      { bit: "Bit2", desc: "DC 성분 전류 과다", code: "Protect0170" },
      { bit: "Bit1", desc: "DCI 센서 오프셋 이상", code: "Protect0180" },
      { bit: "Bit0", desc: "Reserved", code: "" }
    ]
  },
  4: {
    title: "0x0038 Fault2 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Reserved", code: "" },
      { bit: "Bit14", desc: "Reserved", code: "" },
      { bit: "Bit13", desc: "Reserved", code: "" },
      { bit: "Bit12", desc: "PV3 입력 과전압", code: "PV3VoltOver" },
      { bit: "Bit11", desc: "PV3 극성 반대 연결", code: "PV3Reverse" },
      { bit: "Bit10", desc: "PV1 입력 과전압", code: "PV1VoltOver" },
      { bit: "Bit9",  desc: "PV1 극성 반대", code: "PV1Reverse" },
      { bit: "Bit8",  desc: "Reserved", code: "" },
      { bit: "Bit7",  desc: "인버터 오픈루프 자가진단 실패", code: "Protect0230" },
      { bit: "Bit6",  desc: "PV 입력 전반 이상", code: "Protect0260" },
      { bit: "Bit5",  desc: "PV2 입력 과전압", code: "PV2VoltOver" },
      { bit: "Bit4",  desc: "PV2 입력 과전류", code: "Protect0240" },
      { bit: "Bit3",  desc: "PV2 극성 반대", code: "PV2Reverse" },
      { bit: "Bit2",  desc: "Reserved", code: "" },
      { bit: "Bit1",  desc: "내부 하드웨어 오류", code: "Protect0210" },
      { bit: "Bit0",  desc: "Reserved", code: "" }
    ]
  },
  5: {
    title: "0x0039 Fault3 상태 정보",
    rows: [
      { bit: "Bit15", desc: "아크(Arc) 검출 보호", code: "ARC Protect" },
      { bit: "Bit14", desc: "Reserved", code: "" },
      { bit: "Bit13", desc: "게이트 드라이버 전원 이상", code: "Protect0330" },
      { bit: "Bit12", desc: "Reserved", code: "" },
      { bit: "Bit11", desc: "Reserved", code: "" },
      { bit: "Bit10", desc: "Reserved", code: "" },
      { bit: "Bit9",  desc: "Reserved", code: "" },
      { bit: "Bit8",  desc: "Reserved", code: "" },
      { bit: "Bit7",  desc: "Reserved", code: "" },
      { bit: "Bit6",  desc: "Reserved", code: "" },
      { bit: "Bit5",  desc: "Reserved", code: "" },
      { bit: "Bit4",  desc: "Reserved", code: "" },
      { bit: "Bit3",  desc: "Reserved", code: "" },
      { bit: "Bit2",  desc: "Reserved", code: "" },
      { bit: "Bit1",  desc: "Reserved", code: "" },
      { bit: "Bit0",  desc: "Reserved", code: "" }
    ]
  },
  6: {
    title: "0x003A Fault4 상태 정보",
    rows: [
      { bit: "Bit15", desc: "상–대지 전압 이상", code: "Protect0470" },
      { bit: "Bit14", desc: "", code: "" },
      { bit: "Bit13", desc: "", code: "" },
      { bit: "Bit12", desc: "", code: "" },
      { bit: "Bit11", desc: "", code: "" },
      { bit: "Bit10", desc: "CPLD 클럭 이상", code: "Protect0520" },
      { bit: "Bit9",  desc: "CPLD 펌웨어 버전 불일치", code: "Protect0530" },
      { bit: "Bit8",  desc: "제품 모델 불일치", code: "Protect0540" },
      { bit: "Bit7",  desc: "부스트(BST) 회로 과전류", code: "Protect0550" },
      { bit: "Bit6",  desc: "제어보드 3.3V 저전압", code: "Protect0560" },
      { bit: "Bit5",  desc: "PLL Lock 실패", code: "Protect0570" },
      { bit: "Bit4",  desc: "PV3 입력 과전류", code: "Protect0580" },
      { bit: "Bit3",  desc: "배터리 보드 이상", code: "Protect0590" },
      { bit: "Bit2",  desc: "ARC 검출 보드 고장", code: "Arcboard Err" },
      { bit: "Bit1",  desc: "정상 상태 누설전류 지속 발생", code: "Protect0610" },
      { bit: "Bit0",  desc: "제어보드 5V 저전압", code: "Protect0620" }
    ]
  },
  7: {
    title: "0x0035 Warn 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Reserved", code: "" },
      { bit: "Bit14", desc: "Reserved", code: "" },
      { bit: "Bit13", desc: "PV 스트링 이상", code: "PVStrErr" },
      { bit: "Bit12", desc: "PID Box 통신 실패", code: "Pid Box CommErr" },
      { bit: "Bit11", desc: "PID Box 자체 고장", code: "Pid Box Err" },
      { bit: "Bit10", desc: "AC측 서지 보호기(MOV) 이상", code: "Warn0100" },
      { bit: "Bit9",  desc: "Reserved", code: "" },
      { bit: "Bit8",  desc: "Reserved", code: "" },
      { bit: "Bit7",  desc: "AC측 피뢰기 이상", code: "Warn0070" },
      { bit: "Bit6",  desc: "Reserved", code: "" },
      { bit: "Bit5",  desc: "온도 센서 이상", code: "Warn0050" },
      { bit: "Bit4",  desc: "DC측 피뢰기 이상", code: "Warn0040" },
      { bit: "Bit3",  desc: "비휘발성 메모리 오류", code: "Warn0030" },
      { bit: "Bit2",  desc: "내부 통신 오류", code: "CommErr" },
      { bit: "Bit1",  desc: "내부 팬 이상", code: "IntFanErr" },
      { bit: "Bit0",  desc: "외부 팬 이상", code: "ExtFanErr" }
    ]
  },
  8: {
    title: "0x0034 PFault 상태 정보",
    rows: [
      { bit: "Bit15", desc: "제어보드 전원 + 드라이브 전원 동시 이상", code: "Fault0160" },
      { bit: "Bit14", desc: "오픈루프 자가진단 실패", code: "Fault0150" },
      { bit: "Bit13", desc: "내부 하드웨어 고장", code: "Fault0140" },
      { bit: "Bit12", desc: "전력 모듈 영구 손상", code: "Fault0010" },
      { bit: "Bit11", desc: "DC BUS 하드웨어 과전압", code: "Fault0020" },
      { bit: "Bit10", desc: "", code: "" },
      { bit: "Bit9",  desc: "", code: "" },
      { bit: "Bit8",  desc: "하드웨어 과전류", code: "Fault0050" },
      { bit: "Bit7",  desc: "CPLD 클럭 고장", code: "Fault0060" },
      { bit: "Bit6",  desc: "DC 성분 전류 과다", code: "Fault0070" },
      { bit: "Bit5",  desc: "부스트(BST) 회로 과전류", code: "Fault0080" },
      { bit: "Bit4",  desc: "지속 누설전류 보호 실패", code: "Fault0090" },
      { bit: "Bit3",  desc: "계통 릴레이 고장", code: "Fault0100" },
      { bit: "Bit2",  desc: "DC BUS 고전압 지속", code: "Fault0110" },
      { bit: "Bit1",  desc: "", code: "" },
      { bit: "Bit0",  desc: "BUS 고전압 복합 고장", code: "Fault0130" }
    ]
  },
};

const IvError = ({ SelInverter }) => {
  const ivData = useSelector(state => state.ivData || {});
  const [openModalNum, setOpenModalNum] = useState(null);
  const closeModal = () => setOpenModalNum(null);

  const parseBitFlags = (value) => {
    const flags = {};
    for (let i = 15; i >= 0; i--) {
      flags[`Bit${i}`] = (value & (1 << i)) !== 0;
    }
    return flags;
  };

  const isStatusAbnormal = (registerKey, value) => {
    if (typeof value !== 'number') return false;
    const bin = value.toString(2).padStart(16, '0');
    if (registerKey === 'mode') {
      for (let i = 0; i < 16; i++) {
        if (i !== 3 && bin[i] === '1') return true;
      }
      return false;
    } else {
      return bin.includes('1');
    }
  };

  const renderModalContent = () => {
    const modal = AlarmModalData[openModalNum];
    if (!modal) return null;

    const valueMap = {
      1: "mode",
      2: "fault0",
      3: "fault1",
      4: "fault2",
      5: "fault3",
      6: "fault4",
      7: "Warn",
      8: "Pfault",
    };

    // console.log("비트맵")


    const selectedValue = getIvFieldValue(ivData, valueMap[openModalNum], SelInverter, 0);
    const activeBits = parseBitFlags(selectedValue);
    



    return (
      <>
        <Modal.Header closeButton>
          <Modal.Title>{modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered size="sm">
            <tbody>
              {modal.rows.map((row, idx) => {
                const isActive = activeBits[row.bit.trim()];

                return (
                  <tr key={idx} className={isActive ? "active-row" : ""}>
                    <td>{row.bit}</td>
                    <td>{row.desc}</td>
                    <td>{row.code}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>닫기</Button>
        </Modal.Footer>
      </>
    );
  };

  return (
    <div className="status-list-container">
      <div className="status-list">
        {[
          { label: "0x002F (Mode)", key: "mode", num: 1 },
          { label: "0x0036 (Fault0)", key: "fault0", num: 2 },
          { label: "0x0037 (Fault1)", key: "fault1", num: 3 },
          { label: "0x0038 (Fault2)", key: "fault2", num: 4 },
          { label: "0x0039 (Fault3)", key: "fault3", num: 5 },
          { label: "0x003A (Fault4)", key: "fault4", num: 6 },
          { label: "0x0035 (Warn)", key: "Warn", num: 7 },
          { label: "0x0034 (PFault)", key: "Pfault", num: 8 },
        ].map(({ label, key, num }) => {
          const value = getIvFieldValue(ivData, key, SelInverter, "-");
          // console.log("원본 value 타입:", typeof value, "값:", value);
          const isAbnormal = isStatusAbnormal(key, value);
          return (
            <div key={num} className="status-item">
              <span className="status-value">{label}: {value}</span>
              <button onClick={() => setOpenModalNum(num)}>
                <span className={isAbnormal ? 'blinking-icon' : ''}>
                  {isAbnormal ? '🔴' : '🟢'}
                </span>
              </button>
            </div>
          );
        })}
      </div>

      {openModalNum !== null && (
        <Modal show onHide={closeModal} size="lg">
          {renderModalContent()}
        </Modal>
      )}
    </div>
  );
};

export default IvError;
